export default "/images/vendor/flag-icon-css/flags/1x1/sz.svg?5d494168348fddfa3aeb364ab6c2e3ea";